import { render, staticRenderFns } from "./EditorTopBar.vue?vue&type=template&id=df772c82&scoped=true"
import script from "./EditorTopBar.vue?vue&type=script&lang=js"
export * from "./EditorTopBar.vue?vue&type=script&lang=js"
import style0 from "./EditorTopBar.vue?vue&type=style&index=0&id=df772c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df772c82",
  null
  
)

export default component.exports